'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _eventPool = require('../eventPool');

var eventPoolInterface = _interopRequireWildcard(_eventPool);

var _event = require('../event');

var eventInterface = _interopRequireWildcard(_event);

var _dictionary = require('../dictionary');

var dictionaryInterface = _interopRequireWildcard(_dictionary);

var _identifiers = require('../identifiers');

var identifiersInterface = _interopRequireWildcard(_identifiers);

var _metaProperties = require('../metaProperties');

var metaPropertiesInterface = _interopRequireWildcard(_metaProperties);

var _scheduler = require('../scheduler');

var schedulerInterface = _interopRequireWildcard(_scheduler);

var _track = require('../track');

var trackInterface = _interopRequireWildcard(_track);

var _tracker = require('../tracker');

var trackerInterface = _interopRequireWildcard(_tracker);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var create = exports.create = function create(_ref) {
  var getDebug = _ref.getDebug,
      getEmail = _ref.getEmail,
      getHubId = _ref.getHubId,
      getHstc = _ref.getHstc,
      getLang = _ref.getLang,
      getTempStorage = _ref.getTempStorage,
      setTempStorage = _ref.setTempStorage,
      send = _ref.send,
      reportError = _ref.reportError,
      logMessage = _ref.logMessage,
      logError = _ref.logError;

  var eventPool = eventPoolInterface.create({
    getTempStorage: getTempStorage,
    setTempStorage: setTempStorage
  });
  var sendToNetwork = function sendToNetwork(_ref2, events) {
    var identifiers = _ref2.identifiers,
        _ref2$isBeforeUnload = _ref2.isBeforeUnload,
        isBeforeUnload = _ref2$isBeforeUnload === undefined ? false : _ref2$isBeforeUnload;

    var isAuthed = !!(identifiers.raw.email && identifiers.raw.hubId);
    send({
      events: events,
      isBeforeUnload: isBeforeUnload,
      isAuthed: isAuthed,
      query: 'clientSendTimestamp=' + Date.now()
    });
  };
  var flushPoolAndSendToNetwork = function flushPoolAndSendToNetwork(_ref3) {
    var identifiers = _ref3.identifiers;

    var events = eventPool.flush();
    if (events && events.length) {
      sendToNetwork({ identifiers: identifiers }, events);
    }
  };
  var sendToPool = function sendToPool(_ref4, event) {
    var identifiers = _ref4.identifiers;

    if (!eventPool.getIsInitialized()) {
      eventPool.initialize({
        normalizeEvent: function normalizeEvent() {
          for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
            rest[_key] = arguments[_key];
          }

          return eventInterface.normalize.apply(eventInterface, [identifiers].concat(rest));
        }
      });
    }
    eventPool.push(event);
    schedulerInterface.schedule(function () {
      return flushPoolAndSendToNetwork({ identifiers: identifiers });
    });
  };
  var getMetaProperties = function getMetaProperties() {
    return metaPropertiesInterface.get({
      getTempStorage: getTempStorage,
      setTempStorage: setTempStorage
    });
  };
  var createEvent = function createEvent() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return eventInterface.createPayload.apply(eventInterface, [{
      metaProperties: getMetaProperties()
    }].concat(args));
  };
  var onTrack = function onTrack() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return trackInterface.toIoPath.apply(trackInterface, [{
      sendToPool: sendToPool,
      sendToNetwork: sendToNetwork
    }].concat(args));
  };

  return {
    createTracker: function createTracker() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return trackerInterface.createLocked({
        createDictionary: dictionaryInterface.create,
        createIdentifiers: identifiersInterface.create,
        createEvent: createEvent,
        onTrack: onTrack,
        getDebug: getDebug,
        getEmail: getEmail,
        getHubId: getHubId,
        getHstc: getHstc,
        getLang: getLang,
        reportError: reportError,
        logError: logError,
        logMessage: logMessage
      }, config);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.74/js/client/factory.js
// module id = 388
// module chunks = 0